import React, { useEffect } from "react";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import Loading from "../../components/loading";
import { withTranslation } from "react-i18next";

const Valid = (props) => {
  const { t } = props;
  const history = useHistory();
  useEffect(() => {
    if (sessionStorage.getItem("access_token")) {
      history.push("/home-sso");
    } else {
      history.push("/");
    }

    message.success(t("validation.message"));
  }, [history, t]);

  return (
    <div>
      <Loading />
    </div>
  );
};

export default withTranslation()(Valid);
